import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {FormSummaryModel} from '../formSummary.model';
import {Injectable} from '@angular/core';
import {PartnerSummaryConverter} from '../../../../../partner/common/api/converter/partnerSummary.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {DateConverter} from '../../../../../common/converter/date.converter';
import {DocumentSummaryConverter} from '../../../../../document/common/api/converter/DocumentSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class FormSummaryConverter extends HttpModelConverter<FormSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private documentSummaryConverter: DocumentSummaryConverter,
                private dateConverter: DateConverter,
                private partnerSummaryConverter: PartnerSummaryConverter) {
        super();
    }

    protected createInstance(): FormSummaryModel {
        return new FormSummaryModel();
    }

    protected enrichObject(result: FormSummaryModel, src: FormSummaryModel) {
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.status = this.lovValueSummaryConverter.convert(src.status);
        result.date = this.dateConverter.convert(src.date);
        result.documents = this.documentSummaryConverter.convertFromArray(src.documents);
    }
}
